import { authApiCall } from "../../../auth";

// userType: 'customer' | 'business'
export const getNewUsers = (userType, limit = 20) => {
  return authApiCall({
    url: `/users/admin/new-users/?type=${userType}&limit=${limit}`,
    method: 'get',
  });
};
